import styled from "styled-components";
import Button from "@mui/material/Button";

const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    animation: fadeIn 0.2s ease-in-out;

    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
`;

const ModalContainer = styled.div`
    position: relative;
    display: flex;
    width: 327px;
    padding: 24px 16px;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    border-radius: 8px;
    background: var(--Light-Pure, #fff);
    animation: slideUp 0.3s ease-in-out;

    @keyframes slideUp {
        from {
            transform: translateY(20px);
            opacity: 0;
        }
        to {
            transform: translateY(0);
            opacity: 1;
        }
    }
`;

const ContainerText = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
`;

const TitleModal = styled.p`
    color: #181122;
    font-family: Montserrat;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    text-transform: uppercase;
    text-align: center;
`;

const SubTitleModal = styled.p`
    color: #181122;
    font-family: Montserrat;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    text-align: center;
    line-height: 20px;
`;

const ContainerButtons = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    width: 100%;
`;

const PrimaryButton = styled(Button)`
    && {
        background: #57c4c2;
        color: #000;
        font-family: Montserrat;
        font-size: 14px;
        font-weight: 600;
        text-transform: none;
        padding: 12px 16px;
        border-radius: 8px;
        width: 100%;
        text-transform: uppercase;

        &:hover {
            background: #4ba09b;
        }

        &:disabled {
            background: #e4e4e4;
            color: #999;
        }
    }
`;

const SecondaryButton = styled(Button)`
    && {
        background: transparent;
        color: #000;
        font-family: Montserrat;
        font-size: 14px;
        font-weight: 600;
        text-transform: none;
        padding: 12px 16px;
        width: 100%;
        text-transform: uppercase;
        border-radius: 8px;
        border: 1px solid #000;

        &:hover {
            background: #57c4c21a;
        }

        &:disabled {
            background: #e4e4e4;
            color: #999;
        }
    }
`;

const IconeAlert = styled.img`
    width: 24px;
    height: 24px;
`;



export default function ModalSuccesfulNewPlan({ open, onClose, zIndex }) {
    if (!open) return null;

    return (
        <ModalOverlay onClick={() => onClose()} style={{ zIndex: zIndex || 8000 }}>
            <ModalContainer onClick={(e) => e.stopPropagation()}>
                <IconeAlert
                    src="/img/check-circle-broken.svg"
                />
                <ContainerText>
                    <TitleModal>
                        Parabéns, seu novo plano foi configurado!
                    </TitleModal>
                    <SubTitleModal>
                        Preencha os dados de faturamentos e libere a emissão da nota fiscal.
                    </SubTitleModal>
                </ContainerText>
                <ContainerButtons>
                    <SecondaryButton
                        onClick={() => onClose()}
                    >
                        Deixar para depois
                    </SecondaryButton>
                    <PrimaryButton
                        onClick={() => {
                            window.location.href = "/settings?openBillingData=true";
                        }}
                    >
                        preencher agora
                    </PrimaryButton>
                </ContainerButtons>
            </ModalContainer>
        </ModalOverlay>
    );
}
